import { Button, Card, Input, Form, Select } from "antd";

import { useCreateConcurrentRequest } from "./index.hook";
import { formItemLayout, inputLayout } from "../../constants/ApplicationConstants/FormConstants";
import FormInputRules from "../../util/FormInputRules";
import Loading from "../common/Loading";
import CircularProgressBar from "../common/CircularProgressBar";

const CreateConcurrentRequest = () => {
  const config = useCreateConcurrentRequest();

  return (
    <Card className="gx-card card--height" title={"Concurrent Request"}>
      {config.loading ? (
        <Loading />
      ) : (
        <Form
          className="formDiv formDivExtended"
          {...formItemLayout}
          onValuesChange={(changedValues) => {
            const fieldName = Object.keys(changedValues)[0];
            config.form.validateFields([fieldName]);
          }}
          validateTrigger="onBlur"
          colon={false}
          form={config.form}
          onFinish={config.handleSubmit}
        >
          {/* Customer Dropdown */}
          <Form.Item {...inputLayout} label="Customer" name="customerId" rules={[{ required: true, message: "Please select a customer." }]}>
            <Select placeholder="Select Customer" className="dropdown__selector" value={config.customerId} onChange={config.handleChangeCustomer}>
              {config.customerMasterList?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.customer_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* Location Dropdown */}
          <Form.Item {...inputLayout} label="Location" name="locationName" rules={[{ required: true, message: "Please select a location." }]}>
            <Select placeholder="Select Location" className="dropdown__selector">
              {config.locationList?.map((item: { id: number; location_name: string }) => (
                <Select.Option key={item.id} value={item.location_name}>
                  {item.location_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* Booking Request */}
          <Form.Item {...inputLayout} name="bookingKeyFobs" label="Booking Request" rules={[FormInputRules.multipleNumberRangeValidation]}>
            <Input placeholder="Enter comma separated KeyFob eg. 200, 201 (only key-fobs whose allocations are done will be accepted)" />
          </Form.Item>

          {/* Retrieval Request */}
          <Form.Item {...inputLayout} name="retrievalKeyFobs" label="Retrieval Request" rules={[FormInputRules.multipleNumberRangeValidation]}>
            <Input placeholder="Enter comma separated KeyFob eg. 200, 201 (only key-fobs whose allocations are done will be accepted)" />
          </Form.Item>

          {/* Submit Button */}
          <Form.Item className="form-button form-button-pr">
            <Button className="gx-mb-0 button-gradiant" htmlType="submit" disabled={config.saving}>
              {config.saving ? <CircularProgressBar /> : "Submit"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
};

export default CreateConcurrentRequest;
